// extracted by mini-css-extract-plugin
export var label = "_j8-2";
export var slideContainer = "_j8-0";
export var slider = "_j8-1";